import { updateSettings } from 'core/api/settings';
import { Settings } from 'luxon';
import { useState } from 'react';
import { IPaymentusSettings } from 'types';
import EditPanel from 'ui/components/edit-panel/EditPanel';
import FormSectionHeader from 'ui/form-section-header/FormSectionHeader';
import ApplicationPaymentsIcon from 'ui/icons/ApplicationPaymentsIcon';

import { Box, Card, CardContent } from '@mui/material';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import PaymentusSettingsForm from './PaymentusSettingsForm';
import PaymentusSettingsView from './PaymentusSettingsView';
import { FormValues } from './validation-schema';

export interface PaymentusSettingsProps {
  data: IPaymentusSettings;
}

export default function PaymentusSettings(props: PaymentusSettingsProps) {
  const { data } = props;

  const queryClient = useQueryClient();
  const queryKey = ['settings'];

  const [mode, setMode] = useState<'edit' | 'view'>('view');

  const mutation = useMutation({
    mutationFn: (data: Partial<Settings>) => updateSettings(data),
    onSuccess: (responseData) => {
      queryClient.setQueryData(queryKey, responseData);
      setMode('view');
    },
  });

  const onDataSubmit = (v: FormValues) => {
    const data = { paymentusSettings: v };
    mutation.mutate(data);
  };

  return (
    <>
      <FormSectionHeader
        title="Paymentus Settings"
        subtitle="Configure Paymentus settings for your application"
        icon={
          <Box fontSize="6.2rem">
            <ApplicationPaymentsIcon fontSize="inherit" />
            {/* <PaymentsIcon fontSize="inherit" /> */}
          </Box>
        }
      />

      <Card
        sx={{
          ml: 9,
        }}
        className="secondaryLevel no-shadow"
      >
        <CardContent>
          <EditPanel
            mode={mode}
            formComponent={
              <PaymentusSettingsForm
                defaults={data}
                onFormSubmit={onDataSubmit}
                onFormCancel={() => {
                  setMode('view');
                }}
                isLoading={mutation.isPending}
              />
            }
            viewComponent={
              <PaymentusSettingsView
                isEditable={true}
                data={data}
                onEdit={() => {
                  setMode('edit');
                }}
              />
            }
          />
        </CardContent>
      </Card>
    </>
  );
}
